// extracted by mini-css-extract-plugin
export default {"cls1":"PaperNewsStory-cls1_V_g","cls2":"PaperNewsStory-cls2__0V PaperNewsStory-cls1_V_g","variant-dense":"PaperNewsStory-variant-dense_jGo"};